import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.requireState();
    }

    render({ transits }) {
        if (!transits) {
            return (
                <planet-tracker />
            );
        }

        return (
            <planet-tracker>
                <header>
                    <h1 class='widget-header'>Planet Tracker</h1>
                    <hr class='widget-only' />
                    <h2 class='widget-header'>Your daily guide to the changing sky</h2>
                    <hr class='full-only' />
                    <h3 class='text-header-3'>
                        Your sky for <time>{ moment().format('MMMM D, YYYY') }</time>
                    </h3>
                </header>

                <ul>
                    {transits.map(this.renderTransit)}
                </ul>
            </planet-tracker>
        );
    }

    renderTransit({ planet, sign, date_range }) {
        // planet and sign are title-cased
        const href = `/astrology/planets/${planet}-in-${sign}`.toLowerCase();
        const classes = `icon-planet icon-planet-${planet}`.toLowerCase();
        return (
            <li>
                <a href={href}>
                    <div class={classes} />
                    <dl>
                        <dd>{ planet } in { sign }</dd>
                        <dt>{ date_range }</dt>
                    </dl>
                </a>
            </li>
        );
    }

    static mapStateToProps = (state) => (
        state['planet-tracker'] ? state['planet-tracker'].data : {}
    )

    static mapDispatchToProps = (dispatch) => ({
        requireState: () => dispatch({ type: 'planet-tracker:init' }),
    })
}

export default connect(Component.mapStateToProps, Component.mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/planet-tracker.js